module.exports = __webpack_public_path__ + "static/media/credit-card.765d6e75.svg";